import styled from 'styled-components';

import { colours } from 'themes/default';

export const TravelDate = styled.p`
  line-height: 24px;
  font-weight: 600;
  text-decoration: underline;
  color: ${colours.Greyscale.CharcoalGrey};
  display: inline-block;
  margin: 0 0 20px 0;
`;

export const ExtrasList = styled.div`
  margin-top: 30px;
`;
